var _g, _g2, _g3, _g4, _g5, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignupBonus = function SvgSignupBonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 59"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    filter: "url(#signup-bonus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__b)",
    stroke: "url(#signup-bonus_svg__c)",
    d: "M16.252 21.374h4.202q1.991 0 3.016.363 1.025.361 1.656 1.465.63 1.103.63 3.557 0 1.659-.445 2.312-.445.654-1.756 1.004 1.463.387 1.98 1.282.521.895.52 2.742v1.755q0 1.918-.374 2.842-.375.924-1.196 1.264-.82.339-3.36.34h-4.873zm4.211 3.238v4.207q.27-.011.421-.012.62 0 .79-.356t.17-2.04q0-.889-.14-1.245t-.366-.45-.875-.106zm0 7.154v5.294q.892-.035 1.135-.327.246-.292.245-1.438v-1.766q0-1.215-.22-1.472t-1.161-.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__d)",
    stroke: "url(#signup-bonus_svg__e)",
    d: "M37.19 32.455q-.001 2.852-.116 4.038a5 5 0 0 1-.72 2.17 4.05 4.05 0 0 1-1.636 1.507q-1.031.526-2.401.526c-.913 0-1.645-.167-2.337-.497a3.97 3.97 0 0 1-1.665-1.49 4.9 4.9 0 0 1-.75-2.162q-.121-1.17-.122-4.092v-3.237q0-2.854.115-4.038a5 5 0 0 1 .72-2.17 4.04 4.04 0 0 1 1.637-1.508q1.03-.525 2.4-.525 1.3 0 2.337.497 1.035.497 1.665 1.49.63.994.751 2.162.12 1.168.121 4.092zm-4.212-6.218q0-1.32-.126-1.688a.5.5 0 0 0-.515-.368q-.33 0-.505.298-.174.296-.174 1.76v8.837q0 1.648.115 2.033.114.387.535.386c.28 0 .47-.148.55-.444q.12-.444.121-2.116v-8.698z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__f)",
    stroke: "url(#signup-bonus_svg__g)",
    d: "M48.165 21.374v18.923h-3.692l-2.191-8.603v8.603H38.76V21.374h3.522l2.36 8.521v-8.521z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__h)",
    stroke: "url(#signup-bonus_svg__i)",
    d: "M59.43 21.374v12.647q0 2.15-.12 3.02-.12.873-.709 1.79a3.83 3.83 0 0 1-1.555 1.391q-.966.475-2.276.474-1.45 0-2.561-.561-1.11-.56-1.66-1.462a4.44 4.44 0 0 1-.65-1.9q-.101-.998-.1-4.202V21.375h4.211v14.19q0 1.24.115 1.583.115.345.465.345.4 0 .515-.38t.115-1.794V21.374h4.211z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__j)",
    stroke: "url(#signup-bonus_svg__k)",
    d: "M69.984 27.102h-3.912V25.7q0-.982-.15-1.251t-.5-.268q-.38 0-.575.363-.195.36-.196 1.098 0 .949.219 1.428.21.48 1.19 1.158 2.812 1.95 3.541 3.2t.731 4.033q0 2.023-.405 2.98-.404.959-1.566 1.606-1.161.65-2.7.649-1.691 0-2.886-.749-1.195-.748-1.566-1.905t-.37-3.284V33.52h3.912v2.303q0 1.064.165 1.367.166.303.586.304.419 0 .625-.386.204-.386.205-1.145 0-1.672-.39-2.186-.4-.513-1.971-1.718-1.57-1.218-2.081-1.766-.512-.549-.846-1.518-.335-.97-.335-2.479 0-2.173.476-3.178.474-1.005 1.535-1.573 1.06-.566 2.561-.566 1.641 0 2.797.62t1.531 1.56q.375.942.375 3.196v.749z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#signup-bonus_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__m)",
    d: "M17.266 25.602c-1.036-.278-1.697-1.32-1.576-2.602.18-1.919 1.179-3.21 2.421-4.29.157-.137.274-.34.362-.592-.91.571-1.757.843-2.458-.125-.565.449-1.054.988-1.635 1.267-1.169.562-2.012-.176-2.035-1.673-.004-.34-.018-.695.056-1.015.372-1.576.76-3.144 1.173-4.705.055-.208.269-.485.418-.492.165-.005.446.236.485.422.112.565.243 1.182.161 1.732-.142.96-.47 1.876-.66 2.826a9 9 0 0 0-.145 1.773c.001.455.268.557.545.27.235-.245.482-.53.603-.863.272-.747.524-1.515.678-2.306.316-1.628.939-3.03 1.928-4.198.2-.237.43-.449.67-.63.695-.526 1.19-.493 1.844.092.026-.052.044-.11.075-.156.161-.248.326-.49.49-.736.206.238.544.446.594.726.1.548.13 1.16.03 1.701-.28 1.481-.645 2.939-.975 4.406-.038.17-.064.345-.05.552.65-.745 1.32-1.458 1.604-2.54.438-1.659.884-3.312 1.356-4.956.07-.242.295-.42.45-.627.173.203.366.388.51.616.097.151.125.365.202.613.328-.402.61-.787.925-1.125.565-.603.985-.708 1.4-.403.479.352.7 1.02.528 1.792-.184.829-.448 1.633-.634 2.463a14.4 14.4 0 0 0-.313 1.995c-.02.248.178.525.276.786.209-.125.512-.184.61-.386.367-.754.66-1.562 1-2.335.09-.205.251-.366.379-.547.122.197.273.38.355.596.064.174.072.395.058.59-.09 1.366-1.432 2.952-2.572 3.056-.892.08-1.449-.402-1.546-1.455a6 6 0 0 1 .09-1.723c.213-1.046.515-2.066.78-3.096.04-.15.07-.303.035-.535-.172.186-.358.354-.511.56-.917 1.214-1.487 2.648-1.84 4.215-.163.735-.296 1.477-.473 2.207-.059.247-.213.46-.323.688-.197-.139-.4-.266-.59-.416-.065-.051-.104-.152-.154-.23-.622.555-1.237 1.087-1.83 1.656-.11.105-.134.349-.177.533-.357 1.476-.67 2.97-1.077 4.427-.25.893-.683 1.69-1.414 2.176l-.099.023zm2.189-14.423c-1.156.786-2.387 3.849-2.277 5.516.021.328.185.645.284.968.222-.216.516-.382.655-.66a14.2 14.2 0 0 0 1.402-4.884c.03-.276-.037-.568-.064-.94m-1.275 8.81c-1.005 1.24-1.62 3.33-1.226 4.321.703-1.346.97-2.776 1.226-4.32"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M17.266 25.602c-1.036-.278-1.697-1.32-1.576-2.602.18-1.919 1.179-3.21 2.421-4.29.157-.137.274-.34.362-.592-.91.571-1.757.843-2.458-.125-.565.449-1.054.988-1.635 1.267-1.169.562-2.012-.176-2.035-1.673-.004-.34-.018-.695.056-1.015.372-1.576.76-3.144 1.173-4.705.055-.208.269-.485.418-.492.165-.005.446.236.485.422.112.565.243 1.182.161 1.732-.142.96-.47 1.876-.66 2.826a9 9 0 0 0-.145 1.773c.001.455.268.557.545.27.235-.245.482-.53.603-.863.272-.747.524-1.515.678-2.306.316-1.628.939-3.03 1.928-4.198.2-.237.43-.449.67-.63.695-.526 1.19-.493 1.844.092.026-.052.044-.11.075-.156.161-.248.326-.49.49-.736.206.238.544.446.594.726.1.548.13 1.16.03 1.701-.28 1.481-.645 2.939-.975 4.406-.038.17-.064.345-.05.552.65-.745 1.32-1.458 1.604-2.54.438-1.659.884-3.312 1.356-4.956.07-.242.295-.42.45-.627.173.203.366.388.51.616.097.151.125.365.202.613.328-.402.61-.787.925-1.125.565-.603.985-.708 1.4-.403.479.352.7 1.02.528 1.792-.184.829-.448 1.633-.634 2.463a14.4 14.4 0 0 0-.313 1.995c-.02.248.178.525.276.786.209-.125.512-.184.61-.386.367-.754.66-1.562 1-2.335.09-.205.251-.366.379-.547.122.197.273.38.355.596.064.174.072.395.058.59-.09 1.366-1.432 2.952-2.572 3.056-.892.08-1.449-.402-1.546-1.455a6 6 0 0 1 .09-1.723c.213-1.046.515-2.066.78-3.096.04-.15.07-.303.035-.535-.172.186-.358.354-.511.56-.917 1.214-1.487 2.648-1.84 4.215-.163.735-.296 1.477-.473 2.207-.059.247-.213.46-.323.688-.197-.139-.4-.266-.59-.416-.065-.051-.104-.152-.154-.23-.622.555-1.237 1.087-1.83 1.656-.11.105-.134.349-.177.533-.357 1.476-.67 2.97-1.077 4.427-.25.893-.683 1.69-1.414 2.176l-.099.023zm2.189-14.423c-1.156.786-2.387 3.849-2.277 5.516.021.328.185.645.284.968.222-.216.516-.382.655-.66a14.2 14.2 0 0 0 1.402-4.884c.03-.276-.037-.568-.064-.94Zm-1.275 8.81c-1.005 1.24-1.62 3.33-1.226 4.321.703-1.346.97-2.776 1.226-4.32Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#signup-bonus_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__o)",
    d: "M39.076 1.112c.685.4.768 1.145.671 1.867a21 21 0 0 1-.617 2.991 146.455 146.455 0 0 1-1.872 6.171c-.43 1.306-1.184 2.333-2.38 2.846-1.46.625-2.864-.255-3.165-1.989-.22-1.267.008-2.5.337-3.688.609-2.187 1.3-4.348 1.966-6.516.062-.202.185-.378.281-.567l.104-.024c.518.228.8.695.776 1.297a10.3 10.3 0 0 1-.282 2.07c-.487 1.98-1.063 3.934-1.521 5.922-.152.66-.109 1.4-.047 2.09.053.598.476.792.94.496.225-.143.468-.343.588-.59.408-.822.842-1.646 1.124-2.526.465-1.458.797-2.972 1.229-4.446.527-1.793 1.102-3.57 1.656-5.354l.208-.049z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M39.076 1.112c.685.4.768 1.145.671 1.867a21 21 0 0 1-.617 2.991 146.455 146.455 0 0 1-1.872 6.171c-.43 1.306-1.184 2.333-2.38 2.846-1.46.625-2.864-.255-3.165-1.989-.22-1.267.008-2.5.337-3.688.609-2.187 1.3-4.348 1.966-6.516.062-.202.185-.378.281-.567l.104-.024c.518.228.8.695.776 1.297a10.3 10.3 0 0 1-.282 2.07c-.487 1.98-1.063 3.934-1.521 5.922-.152.66-.109 1.4-.047 2.09.053.598.476.792.94.496.225-.143.468-.343.588-.59.408-.822.842-1.646 1.124-2.526.465-1.458.797-2.972 1.229-4.446.527-1.793 1.102-3.57 1.656-5.354l.208-.049z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#signup-bonus_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__q)",
    d: "M10.455 7.789a2.17 2.17 0 0 1 1.472.811c.669.808.863 1.704.515 2.762-.276.84-.529 1.693-.8 2.54-.166.524-.339.582-.716.255-.466-.407-.619-.987-.493-1.61.144-.719.406-1.401.575-2.113.09-.385.093-.798.134-1.2-.325.151-.705.22-.97.464a8.2 8.2 0 0 0-2.248 3.491c-.462 1.387-.228 2.11.906 2.736.6.329 1.232.566 1.852.83.96.41 1.21 1.04.846 2.16-.45 1.38-1.622 2.208-3.047 2.146-1.276-.055-2.4-.623-3.433-1.496-.121-.1-.25-.189-.376-.28l-.061-.358c.65-.626 1.357-.587 2.086-.218.514.259 1.006.616 1.54.775a3.4 3.4 0 0 0 1.533.075c.244-.044.439-.453.655-.697-.193-.22-.353-.518-.582-.647-.838-.48-1.72-.857-2.545-1.363-.94-.575-1.41-1.574-1.22-2.807.142-.91.406-1.834.785-2.634.74-1.57 1.803-2.78 3.197-3.53l.397-.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M10.455 7.789a2.17 2.17 0 0 1 1.472.811c.669.808.863 1.704.515 2.762-.276.84-.529 1.693-.8 2.54-.166.524-.339.582-.716.255-.466-.407-.619-.987-.493-1.61.144-.719.406-1.401.575-2.113.09-.385.093-.798.134-1.2-.325.151-.705.22-.97.464a8.2 8.2 0 0 0-2.248 3.491c-.462 1.387-.228 2.11.906 2.736.6.329 1.232.566 1.852.83.96.41 1.21 1.04.846 2.16-.45 1.38-1.622 2.208-3.047 2.146-1.276-.055-2.4-.623-3.433-1.496-.121-.1-.25-.189-.376-.28l-.061-.358c.65-.626 1.357-.587 2.086-.218.514.259 1.006.616 1.54.775a3.4 3.4 0 0 0 1.533.075c.244-.044.439-.453.655-.697-.193-.22-.353-.518-.582-.647-.838-.48-1.72-.857-2.545-1.363-.94-.575-1.41-1.574-1.22-2.807.142-.91.406-1.834.785-2.634.74-1.57 1.803-2.78 3.197-3.53l.397-.093z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#signup-bonus_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__s)",
    d: "M46.092 9.086c-.441 2.553-2.31 4.15-4.708 4.025-.698-.037-1.283-.316-1.784-.987-.163.554-.324 1.037-.446 1.528-.319 1.29-.615 2.587-.936 3.878-.045.18-.166.47-.262.476-.166.013-.425-.106-.49-.252-.17-.381-.406-.832-.348-1.214.245-1.609.506-3.224.913-4.796.5-1.93 1.15-3.815 1.738-5.72.04-.135.08-.277.156-.39.167-.254.334-.644.545-.688.183-.038.427.323.698.555.082-.065.236-.199.395-.32 1.154-.883 2.393-.418 2.673 1.06.12.632.098 1.32.035 1.973-.062.635-.22 1.274-.406 1.887-.18.59-.451 1.151-.682 1.723q.048.059.1.116c.4-.458.854-.874 1.183-1.387.317-.495.528-1.075.74-1.634.233-.614.33-.67.807-.307l.081.474zM42.58 5.674l-.22-.082c-.218.233-.517.426-.64.705-.494 1.134-1.015 2.268-1.363 3.455-.162.548-.02 1.233.109 1.821.104.473.425.504.75.143.182-.201.34-.44.458-.691.594-1.242 1.008-2.544 1.029-3.944.007-.468-.08-.937-.123-1.405z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M46.092 9.086c-.441 2.553-2.31 4.15-4.708 4.025-.698-.037-1.283-.316-1.784-.987-.163.554-.324 1.037-.446 1.528-.319 1.29-.615 2.587-.936 3.878-.045.18-.166.47-.262.476-.166.013-.425-.106-.49-.252-.17-.381-.406-.832-.348-1.214.245-1.609.506-3.224.913-4.796.5-1.93 1.15-3.815 1.738-5.72.04-.135.08-.277.156-.39.167-.254.334-.644.545-.688.183-.038.427.323.698.555.082-.065.236-.199.395-.32 1.154-.883 2.393-.418 2.673 1.06.12.632.098 1.32.035 1.973-.062.635-.22 1.274-.406 1.887-.18.59-.451 1.151-.682 1.723q.048.059.1.116c.4-.458.854-.874 1.183-1.387.317-.495.528-1.075.74-1.634.233-.614.33-.67.807-.307l.081.474zM42.58 5.674l-.22-.082c-.218.233-.517.426-.64.705-.494 1.134-1.015 2.268-1.363 3.455-.162.548-.02 1.233.109 1.821.104.473.425.504.75.143.182-.201.34-.44.458-.691.594-1.242 1.008-2.544 1.029-3.944.007-.468-.08-.937-.123-1.405z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signup-bonus_svg__t)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M15.44 10.483c.07.459-.116.788-.499.879-.479.116-.991-.25-1.064-.759-.064-.444.193-.89.56-.971.434-.098.922.316 1.003.85Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__b",
    x1: 21.155,
    x2: 21.155,
    y1: 40.297,
    y2: 21.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F7C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3B000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F0A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__c",
    x1: 16.178,
    x2: 26.133,
    y1: 30.837,
    y2: 30.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F2CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E8C200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__d",
    x1: 32.319,
    x2: 32.319,
    y1: 40.696,
    y2: 20.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F7C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3B000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F0A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__e",
    x1: 27.37,
    x2: 37.266,
    y1: 30.836,
    y2: 30.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F2CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E8C200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__f",
    x1: 43.462,
    x2: 43.462,
    y1: 40.297,
    y2: 21.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F7C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3B000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F0A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__g",
    x1: 38.689,
    x2: 48.238,
    y1: 30.836,
    y2: 30.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F2CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E8C200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__h",
    x1: 54.613,
    x2: 54.613,
    y1: 40.696,
    y2: 21.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F7C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3B000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F0A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__i",
    x1: 49.726,
    x2: 59.507,
    y1: 31.035,
    y2: 31.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F2CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E8C200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__j",
    x1: 65.521,
    x2: 65.521,
    y1: 40.696,
    y2: 20.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F7C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3B000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F0A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__k",
    x1: 60.636,
    x2: 70.408,
    y1: 30.837,
    y2: 30.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F2CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E8C200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__m",
    x1: 22.189,
    x2: 18.816,
    y1: 24.454,
    y2: 9.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F7C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F3B000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F0A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__o",
    x1: 36.931,
    x2: 34.069,
    y1: 14.549,
    y2: 2.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F3B000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F0A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__q",
    x1: 9.702,
    x2: 6.84,
    y1: 20.9,
    y2: 8.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F6C000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F1A900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__s",
    x1: 42.3,
    x2: 39.54,
    y1: 16.993,
    y2: 5.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F7C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F3B000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F0A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signup-bonus_svg__t",
    x1: 14.804,
    x2: 14.395,
    y1: 11.396,
    y2: 9.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F7C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3B000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F0A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A100"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "signup-bonus_svg__a",
    width: 75.08,
    height: 40.719,
    x: 12.752,
    y: 17.477,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_40944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_191_40944",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "signup-bonus_svg__l",
    width: 24.885,
    height: 25.463,
    x: 8.217,
    y: 8.272,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_40944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_191_40944",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "signup-bonus_svg__n",
    width: 16.402,
    height: 22.336,
    x: 27.502,
    y: 0.978,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_40944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_191_40944",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "signup-bonus_svg__p",
    width: 16.258,
    height: 21.528,
    x: 0.477,
    y: 7.663,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_40944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_191_40944",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "signup-bonus_svg__r",
    width: 17.25,
    height: 21.525,
    x: 32.986,
    y: 4.608,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_40944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_191_40944",
    result: "shape"
  })))));
};
export default SvgSignupBonus;